import React, { useState,useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import { postRequest } from "../apiRequests/requestApi";
import { useGames } from '../../utils/hooks';


const API_URL = process.env.REACT_APP_API_URL || '';

const GameRating = ({ gameCode, onClose = () => {} }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
   const { games, getGames} = useGames();

 useEffect(() => {
    const fetchGames = async () => {
      try {
        await getGames();
      } catch (error) {
        // console.error("Error fetching games:", error);
      }
    };
    fetchGames();
  }, [getGames]);

  const handleRatingClick = (ratingValue) => {
    setRating(ratingValue);
    if (ratingValue >= 4) {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      });
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const lastGameData = JSON.parse(localStorage.getItem('lastGameData'));
      const gameName = lastGameData?.gameName;
      let gameId = null;
      // console.log(games)
      if (games ) {
        // console.log('Games array found:', games);
        const found = games.find(g => g.id === gameName);
        // console.log('Found game ID:', found);
        if (found) gameId = found._id;
        
      }
      if (!gameId) throw new Error('Game ID not found');
      await postRequest({
        url: `/rating`,
        data: JSON.stringify({
          rating,
          gameId
        })
      });
      setSubmitted(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (e) {
      setSubmitted(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="fixed inset-0 flex justify-center items-center bg-black/60 z-50">
        <div className="bg-[#181c24] rounded-[18px] shadow-lg max-w-[400px] w-full p-8 flex flex-col justify-center items-center gap-2">
          <h2 className="text-white mb-4 text-center text-2xl font-bold font-quantico">Thank You!</h2>
          <p className="text-[#bfc9d8] text-center mb-4 font-poppins">Your feedback has been submitted.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/60 z-50">
      <div className="bg-[#181c24] rounded-[18px] shadow-lg max-w-[400px] w-full p-8 flex flex-col justify-center items-center gap-4">
        <h2 className="text-white mb-4 text-center text-2xl font-bold font-quantico">Rate Your Experience</h2>
        <div className="flex mb-4">
          {[...Array(5)].map((_, index) => {
            const ratingValue = index + 1;
            return (
              <FaStar
                key={index}
                className="cursor-pointer"
                color={ratingValue <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
                size={30}
                style={{ margin: '0 5px' }}
                onClick={() => handleRatingClick(ratingValue)}
                onMouseEnter={() => setHover(ratingValue)}
                onMouseLeave={() => setHover(0)}
              />
            );
          })}
        </div>
        <textarea
          className="w-full p-2 mb-4 bg-[#23283a] text-white rounded-md font-poppins"
          placeholder="Additional feedback (optional)"
          rows={4}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />
        <div className="w-full flex justify-between gap-4">
          <button
            className="p-2 text-sm w-full rounded-md bg-gray-500 text-white hover:bg-gray-400 transition-all font-poppins"
            onClick={onClose}
            disabled={submitting}
          >
            Skip
          </button>
          <button
            className={`p-2 text-sm w-full rounded-md text-white transition-all font-poppins ${rating > 0 ? 'bg-blue-500 hover:bg-blue-400' : 'bg-blue-300 cursor-not-allowed'}`}
            onClick={handleSubmit}
            disabled={rating === 0 || submitting}
          >
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameRating;
